export const userKeys = {
  all: ["users"] as const,
  skills: (userId: string) => [...userKeys.all, userId, "skills"] as const,
  professionalConnections: (userId: string) => [...userKeys.all, userId, "professional-connections"] as const,
  experience: (userId: string) => [...userKeys.all, userId, "experience"] as const,
  trophies: (userId: string) => [...userKeys.all, userId, "trophies"] as const,
  reviews: (userId: string) => [...userKeys.all, userId, "reviews"] as const,
  profile: (userId: string) => [...userKeys.all, userId, "profile"] as const,
  certificates: (userId: string) => [...userKeys.all, userId, "certificates"] as const,
  activities: (userId: string, activityType: string) => [...userKeys.all, userId, "activities", activityType] as const,
  search: (params: Record<string, any>) => [...userKeys.all, "search", params] as const,
} as const;
